module.exports = __webpack_public_path__ + "img/RS-M-1.37a0fa05.svg";